import { Box, Text, Portal } from "@chakra-ui/react";
import { useSpeechToTextContext } from "contexts";

export function LiveTranscript() {
  const { transcript, isListening } = useSpeechToTextContext();

  if (!isListening) {
    return null;
  }

  return (
    <Portal>
      <Box
        position="fixed"
        bottom="5%"
        left="50%"
        transform="translateX(-50%)"
        bg="rgba(0, 0, 0, 0.7)"
        color="white"
        p={4}
        borderRadius="md"
        zIndex="tooltip"
        maxWidth="80%"
        textAlign="center"
      >
        <Text fontSize="2xl" fontWeight="bold">
          {transcript}
        </Text>
      </Box>
    </Portal>
  );
}
